$(function () {
    if($('.page--revit-lib').length){
        $(".rangeSelector").change(function(){
            $(".searchBox").val("");
            $(".searchButton").click();
        });

        $(".searchBox").keyup(function(){
            $(".rangeSelector").val(0);
        });

        $(".searchBox").change(function(){
            $(".searchButton").click();
        });

        $(".searchButton").click(function(e){
            e.preventDefault();
            var rangeID = $(".rangeSelector").val();
            var searchText = $(".searchBox").val().trim();
            if(rangeID == 0 && searchText == ""){
                $('.range-row').show();
                $('.model-row').show();
                return;
            }
            $('.range-row').hide();
            $('.model-row').hide();

            if(rangeID != 0){
                $('.range-row').hide();
                $(".model-row").hide();
                $('.range-row[rid="' + rangeID + '"]').show();
                $('.model-row[rid="' + rangeID + '"]').show();
                return;
            }
            if(searchText){
                searchText = searchText.toLowerCase();
                $('.model-name-container').each(function(){
                    var modelName = $(this).html().toLowerCase();
                    if(modelName.includes(searchText)){
                        var rangeID = $(this).closest('.model-row').attr('rid');
                        $('.range-row[rid="' + rangeID + '"]').show();
                        $(this).closest('.model-row').show();
                    }
                });
                return;
            }
        });
    }
});

